import { BrandListResponse, BrandSummary, CreateBrandRequest, RenameBrandRequest, RenameBrandResponse, SetBrandStatusRequest, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchBrands = async (status, signal) => {
    const params = new URLSearchParams();
    if (status !== undefined)
        params.set('status', status);
    const query = params.toString();
    return BrandListResponse.parse(await request(`/api/v1/brands${query === '' ? '' : `?${query}`}`, {
        signal,
    })).brands;
};
export const createBrand = async (input) => BrandSummary.parse(await request('/api/v1/brands', {
    method: 'POST',
    body: CreateBrandRequest.parse(input),
}));
export const setBrandStatus = async (id, input) => BrandSummary.parse(await request(`/api/v1/brands/${id}/status`, {
    method: 'POST',
    body: SetBrandStatusRequest.parse(input),
}));
/**
 * Renomeia a marca, levando o nome novo aos produtos (F160). Se o nome já é
 * outra marca ativa, as duas viram uma — a resposta diz qual das duas coisas
 * aconteceu, e quantos produtos mudaram.
 */
export const renameBrand = async (id, input) => RenameBrandResponse.parse(await request(`/api/v1/brands/${id}`, {
    method: 'PATCH',
    body: RenameBrandRequest.parse(input),
}));
//# sourceMappingURL=brands.js.map